import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import {
  getInvoiceBalanceDue,
  getInvoiceGrossAmount,
  getInvoiceNumber,
  getInvoicePaidAmount,
  getPaymentStatus,
  paymentStatusLabel,
} from "utils/invoiceDashboardUtils";
import { formatMoney } from "utils/utils";

const STATUS_COLORS = { PAID: "success", PARTIALLY_PAID: "warning", UNPAID: "error" };

const Figure = ({ label, value, color, note }) => (
  <Paper variant="outlined" sx={{ p: 1.5 }}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="subtitle1" fontWeight={700} color={color}>
      {formatMoney(value)}
    </Typography>
    {note && (
      <Typography variant="caption" color="text.secondary" component="p">
        {note}
      </Typography>
    )}
  </Paper>
);

const ModuleInvoiceSummary = ({ invoice }) => {
  const total = getInvoiceGrossAmount(invoice);
  const status = getPaymentStatus(invoice);
  const pendingRefunds = Number(invoice.pendingRefundAmount || 0);
  return (
    <Stack spacing={1.5}>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
        <Typography variant="subtitle1" fontWeight={700}>
          {getInvoiceNumber(invoice)}
        </Typography>
        <Chip
          size="small"
          label={paymentStatusLabel(status)}
          color={STATUS_COLORS[status] || "default"}
        />
        <Typography variant="body2" color="text.secondary" noWrap>
          {invoice.title}
        </Typography>
      </Stack>
      <Box className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Figure label="Total" value={total} />
        <Figure
          label="Paid (verified)"
          value={getInvoicePaidAmount(invoice, total)}
          color="success.main"
        />
        <Figure
          label="Pending"
          value={Number(invoice.pendingPaidAmount || 0)}
          color="warning.main"
          note={pendingRefunds > 0 ? `Refunds pending: ${formatMoney(pendingRefunds)}` : null}
        />
        <Figure label="Due" value={getInvoiceBalanceDue(invoice, total)} />
      </Box>
    </Stack>
  );
};

export default ModuleInvoiceSummary;
